export function getLocalDateString() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function timeStringToMinutes(t) {
  const [h, m] = String(t ?? '0:0').split(':').map(Number);
  return (h * 60) + (m || 0);
}
